import { render } from "./ChatInputAnswers.vue?vue&type=template&id=6fad14fa&scoped=true&ts=true"
import script from "./ChatInputAnswers.vue?vue&type=script&lang=ts"
export * from "./ChatInputAnswers.vue?vue&type=script&lang=ts"

import "./ChatInputAnswers.vue?vue&type=style&index=0&id=6fad14fa&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fad14fa"]])

export default __exports__